<template>
  <div class="data-list-container">
  <!-- <vs-row>
    <vs-col vs-w="12">
          <h2><span class="feather icon-box"></span>   Module Customization</h2>
    </vs-col>
  </vs-row> -->
  <h4 class="p-2">Customization</h4>
  <vs-row>
    <vs-col vs-lg="4" vs-sm="12" class="p-2" :key="indextr" v-for="(eachData, indextr) in custom_fields">
      <vs-card class="content_mb_0 mb-0 h-full">
        <div slot="header">
          <h4>{{ eachData.name }}</h4>
        </div>
        <div v-if="eachData.required_fields" style="cursor: pointer" class="light_grey_holder flex justify-between items-center p-4 mb-2" @click="customStaticPopupOpen(eachData.name, eachData)">
            <div class="inline-flex items-center">
              <span class="material-icons-outlined">settings</span>
              <span class="pl-4">REQUIRED FIELD</span>
            </div>
            <span class="material-icons-outlined">arrow_forward_ios</span>
        </div>
        <div v-if="eachData.dynamic_fields" style="cursor: pointer" class="light_grey_holder flex justify-between items-center p-4 mb-2" @click="customDynamicPopupOpen(eachData.name)">
            <div class="inline-flex items-center">
              <span class="material-icons-outlined">settings</span>
              <span class="pl-4">CUSTOMIZE DYNAMIC FIELDS</span>
            </div>
            <span class="material-icons-outlined">arrow_forward_ios</span>
        </div>
        <div style="cursor: pointer" class="light_grey_holder flex justify-between items-center p-4 mb-2" @click="customFilterPopupOpen(eachData.name, eachData)">
            <div class="inline-flex items-center">
              <span class="material-icons-outlined">settings</span>
              <span class="pl-4">FILTER MANAGEMENT</span>
            </div>
            <span class="material-icons-outlined">arrow_forward_ios</span>
        </div>
        <div style="cursor: pointer" class="light_grey_holder flex justify-between items-center p-4" @click="customRearrangementPopupOpen(eachData.name, eachData)">
            <div class="inline-flex items-center">
              <span class="material-icons-outlined">settings</span>
              <span class="pl-4">FIELD RE-ARRANGEMENT</span>
            </div>
            <span class="material-icons-outlined">arrow_forward_ios</span>
        </div>
        <div v-if="eachData.name == 'CRM'" style="cursor: pointer" class="light_grey_holder flex justify-between items-center p-4 mt-2" @click="$router.push({ path: '/pages/statusmanagement' })">
            <div class="inline-flex items-center">
              <span class="material-icons-outlined">settings</span>
              <span class="pl-4">STATUS MANAGEMENT</span>
            </div>
            <span class="material-icons-outlined">arrow_forward_ios</span>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>

  <div v-if="customStaticPopup">
    <CustomStatic :customStaticPopup="customStaticPopup" :modelname="modelname" @closeCustomModal="closeCustomModal" :module_id="module_id" :table_name="table_name" />
  </div>
  <div v-if="customDynamicPopup">
    <CustomDynamic :customDynamicPopup="customDynamicPopup" :modelnamePass="modelname" @closeDynamicModal="closeDynamicModal" />
  </div>
  <div v-if="customFilterPopup">
    <CustomFilter :customFilterPopup="customFilterPopup" :table_name="table_name" :modelnamePass="modelname" @closeFilterModal="closeFilterModal" />
  </div>
  <div v-if="customRearrangementPopup">
    <CustomRearrangement :customRearrangementPopup="customRearrangementPopup" :table_name="table_name" :modelnamePass="modelname" :is_dynamic="is_dynamic" type="settings" @closeRearrangementModal="closeRearrangementModal" />
  </div>  
    
    </div>

</template>
<script>
import { fetch_custom_modules} from '@/api/customfield'
import CustomStatic from '@/views/pages/customsettings/customStatics.vue'
import CustomDynamic from '@/views/pages/customsettings/customdynamiclist.vue'
import CustomFilter from '@/views/pages/customsettings/filterdynamiclist.vue'
import CustomRearrangement from '@/views/pages/customFieldRearrage/RearrangeManagement.vue'

export default {
  name: 'CustomSettings',
  components:{
    CustomStatic,
    CustomDynamic,
    CustomFilter,
    CustomRearrangement
  },
  data () {
    return {
      custom_fields:[],
      customStaticPopup:false,
      customDynamicPopup:false,
      customFilterPopup:false,
      customRearrangementPopup:false,
      modelname:'',
      table_name:'',
      module_id:null,
      is_dynamic:false
    }
  },
  mounted () {
    this.fetch_custom_modules_list()
    
  },
  methods :{
    async closeRearrangementModal () {
      this.customRearrangementPopup = false
      this.modelname = ''
    },
    async closeFilterModal () {
      this.customFilterPopup = false
      this.modelname = ''
    },
    async closeDynamicModal () {
      this.customDynamicPopup = false
      this.modelname = ''
    },
    async closeCustomModal () {
      this.customStaticPopup = false
      this.modelname = ''
    },
    async customStaticPopupOpen (modelname, details) {
      this.customStaticPopup = true
      this.modelname = modelname
      this.table_name = details.table_name[0]
      this.module_id = details.module_id

    },
    async customDynamicPopupOpen (modelname) {
      this.customDynamicPopup = true
      this.modelname = modelname
    },
    async customFilterPopupOpen (modelname, details) {
      console.log(details)
      this.customFilterPopup = true
      this.modelname = modelname
      this.table_name = details.table_name[0]
    },
    async customRearrangementPopupOpen (modelname, details) {
      this.customRearrangementPopup = true
      this.modelname = modelname
      this.table_name = details.table_name[0]
      this.is_dynamic = details.dynamic_fields
    },
    async fetch_custom_modules_list () {

      try {
        const { data } = await fetch_custom_modules()
        this.custom_fields = data.data.models
      } catch (e) {
        console.log(e)
      } finally {
        this.$vs.loading.close()

      }

    }
  }
}
</script>

<style>
 .vs-component .vs-dropdown--item, .vs-dropdown--item-link, .vs-dropdown--group-label, .vs-component .vs-dropdown--group .marginIcon {
    font-weight: 500 !important;
  }
</style>